// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/grid.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./img/builder.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("./img/metric.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_3___ = new URL("./img/barchart.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_4___ = new URL("./img/close.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_5___ = new URL("./img/search-icon.svg", import.meta.url);
// Module
var code = `<!-- grid html -->
<div class="grid-header grid-drag-target edit-mode">
  <!-- edit mode toolbar -->
  <div class="grid-actions">
    <div class="grid-toolbar edit-mode">
      <div class="toolbar-action add-subgrid"><img src="${___HTML_LOADER_IMPORT_0___}" class="toolbar-img edit-mode" alt="grid"></div>
      <div class="toolbar-action add-card"><img src="${___HTML_LOADER_IMPORT_1___}" class="toolbar-img edit-mode" alt="builder"></div>
      <div class="toolbar-action add-metric"><img src="${___HTML_LOADER_IMPORT_2___}" class="toolbar-img edit-mode" alt="metric"></div>
      <div class="toolbar-action add-barchart"><img src="${___HTML_LOADER_IMPORT_3___}" class="toolbar-img edit-mode" alt="barchart"></div>
      <div class="toolbar-action close-grid"><img src="${___HTML_LOADER_IMPORT_4___}" class="toolbar-img edit-mode" alt="close"></div>
    </div>
  </div>
</div>
<div class="grid-header">
  <div class="grid-header-left">
    <div class="grid-title"></div>
    <div class="data-count"></div>
  </div>

  <div class="grid-header-right">
    <div class="toolbar-row toolbar-row-primary">
      <hs-date-range-picker></hs-date-range-picker>
      <div id="search">
        <div class="search-wrapper">
          <input type="text" id="search-text" placeholder="Search..." />
          <img src="${___HTML_LOADER_IMPORT_5___}" alt="Search" class="search-icon" />
        </div>
      </div>
      <hs-time-picker></hs-time-picker>
      <hs-stats-column-picker></hs-stats-column-picker>
      <hs-view-picker></hs-view-picker>
    </div>
  </div>

  <div class="toolbar-row toolbar-row-stats">
    <div class="report-picker-wrapper" style="display:none;">
      <span class="picker-label">Report selector</span>
      <select class="report-picker-select"></select>
    </div>
    <hs-snapshot-picker></hs-snapshot-picker>
  </div>
`;
// Exports
export default code;